import { render, staticRenderFns } from "./Costera.vue?vue&type=template&id=f64dcf9c&scoped=true&lang=pug&"
import script from "./Costera.vue?vue&type=script&lang=js&"
export * from "./Costera.vue?vue&type=script&lang=js&"
import style0 from "./Costera.vue?vue&type=style&index=0&id=f64dcf9c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64dcf9c",
  null
  
)

export default component.exports